import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59456936"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "masonry-column" }
const _hoisted_2 = {
  key: 0,
  class: "latest-feedback"
}
const _hoisted_3 = { class: "masonry-column" }
const _hoisted_4 = {
  key: 0,
  class: "latest-feedback"
}

import { ref, computed, onBeforeMount, onMounted, onDeactivated } from 'vue'
import type { Ref } from 'vue'
import store from '@/mobile/src/store/index'
import router from '@/mobile/src/router/index'
import HomeCube from '@/mobile/src/views/appV4/HomeCube.vue'
import FeedbackCardCarousel from '@/mobile/src/components/appV4/FeedbackCardCarousel.vue'
import Topics from '@/mobile/src/components/appV4/teams/Topics.vue'
import TopicFeedbackCarousel from '@/mobile/src/components/appV4/TopicFeedbackCarousel.vue'
import LoadingCard from '@/mobile/src/components/appV4/LoadingCard.vue'
import { useRoute } from 'vue-router'

interface Props {
    filterKey: string
    refreshTopic: number
    showGoalTracking: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeContent',
  props: {
    filterKey: { default: '' },
    refreshTopic: { default: 0 },
    showGoalTracking: { type: Boolean, default: false }
  },
  emits: ['set-show-report-card', 'toggle-show-goal-tracking'],
  setup(__props: any, { emit: __emit }) {

const route = useRoute()

const mobileQuestionType = computed(() => store.getters['mobileQuestionType'])
const companyVars = computed(() => store.getters['$companyVars'])
const latestFeedback = computed(
    () => store.getters['topicfeedback/latestFeedback']
)
const latestFeedbackLoading = computed(
    () => store.getters['topicfeedback/latestFeedbackLoading']
)

const getLatestFeedback = (metricType: string) => {
    if (!latestFeedback.value.length) {
        store.dispatch('topicfeedback/getLatestFeedback', metricType)
    }
}

const props = __props

const masonryGridRef: Ref<HTMLDivElement | null> = ref(null)

const isTwoColumnLayout = ref(true)

const showLatestFeedback = computed(() => {
    return !companyVars.value?.has_scorecard
})

onBeforeMount(() => {
    getLatestFeedback(mobileQuestionType.value)
})

onMounted(() => {
    calculateColumnLayout()
    window.addEventListener('resize', calculateColumnLayout)
})

onDeactivated(() => {
    window.removeEventListener('resize', calculateColumnLayout)
})

// We want a different template layout for 1 & 2 column, so it must be recalculated on mount and window resize
const calculateColumnLayout = () => {
    const masonryGrid = masonryGridRef.value
    if (masonryGrid) {
        const columnWidth: number =
            parseInt(window.getComputedStyle(masonryGrid)?.columnWidth) ?? 0
        const columnGap: number =
            parseInt(window.getComputedStyle(masonryGrid)?.columnGap) ?? 0

        isTwoColumnLayout.value =
            columnWidth * 2 + columnGap <= masonryGrid.offsetWidth
    }
}

const navigateToFeedback = () => {
    router.push('/myfeedback')
}

const emit = __emit

const onSetShowReportCard = (val) => {
    emit('set-show-report-card', val)
}

const ontoggleShowGoalTracking = (val) => {
    emit('toggle-show-goal-tracking', val)
}

const useSelfOnlyFilter = computed(() => {
    return route?.meta?.group === 'teams'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "home-content",
    ref_key: "masonryGridRef",
    ref: masonryGridRef,
    class: "masonry-grid"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HomeCube, {
        "show-goal-tracking": _ctx.showGoalTracking,
        onSetShowReportCard: onSetShowReportCard,
        onToggleShowGoalTracking: ontoggleShowGoalTracking
      }, null, 8, ["show-goal-tracking"]),
      (isTwoColumnLayout.value)
        ? (_openBlock(), _createBlock(Topics, {
            key: 0,
            "filter-key": _ctx.filterKey,
            "self-only-filter": useSelfOnlyFilter.value,
            title: "Your Scorecard"
          }, null, 8, ["filter-key", "self-only-filter"]))
        : _createCommentVNode("", true),
      (!isTwoColumnLayout.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (showLatestFeedback.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (latestFeedbackLoading.value)
                    ? (_openBlock(), _createBlock(LoadingCard, { key: 0 }))
                    : (_openBlock(), _createBlock(FeedbackCardCarousel, {
                        key: 1,
                        header: "Latest Feedback",
                        "view-all-callback": () => navigateToFeedback(),
                        feedback: latestFeedback.value
                      }, null, 8, ["view-all-callback", "feedback"]))
                ]))
              : (_openBlock(), _createBlock(TopicFeedbackCarousel, { key: _ctx.refreshTopic }))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (!isTwoColumnLayout.value)
        ? (_openBlock(), _createBlock(Topics, {
            key: 0,
            "filter-key": _ctx.filterKey,
            "self-only-filter": useSelfOnlyFilter.value,
            title: "Your Scorecard"
          }, null, 8, ["filter-key", "self-only-filter"]))
        : _createCommentVNode("", true),
      (isTwoColumnLayout.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (showLatestFeedback.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (latestFeedbackLoading.value)
                    ? (_openBlock(), _createBlock(LoadingCard, { key: 0 }))
                    : (_openBlock(), _createBlock(FeedbackCardCarousel, {
                        key: 1,
                        header: "Latest Feedback",
                        "view-all-callback": () => navigateToFeedback(),
                        feedback: latestFeedback.value
                      }, null, 8, ["view-all-callback", "feedback"]))
                ]))
              : (_openBlock(), _createBlock(TopicFeedbackCarousel, { key: _ctx.refreshTopic }))
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 512))
}
}

})